/** Normalize possible_matches: accept array of column names or object { col: score } */
export function normalizePossibleMatches(pm) {
  if (!pm) return {};
  if (Array.isArray(pm)) {
    return Object.fromEntries(pm.map((col, i) => [col, 1 - i * 0.01]));
  }
  return typeof pm === 'object' ? pm : {};
}

/** Section key: direct, compute, concat, join, aggregate, no_mapping, or other */
export function getMappingSectionKey(mappingType) {
  const t = (mappingType || '').toUpperCase().replace(/-/g, '_');
  if (t === 'DIRECT') return 'direct';
  if (t === 'COMPUTE') return 'compute';
  if (t === 'CONCAT') return 'concat';
  if (t === 'JOIN') return 'join';
  if (t === 'AGGREGATE') return 'aggregate';
  if (t === 'NO_MAPPING') return 'no_mapping';
  return 'other';
}

export const MAPPING_SECTION_LABELS = {
  direct: 'Direct mapping',
  compute: 'Compute',
  concat: 'Concat',
  join: 'Join',
  aggregate: 'Aggregate',
  no_mapping: 'No mapping',
  other: 'Other',
};

/** Section display order (direct and compute are separate sections) */
export const MAPPING_SECTION_ORDER = ['direct', 'compute', 'join', 'concat', 'aggregate', 'no_mapping', 'other'];
